export enum RfpStatus {
    DRAFT = "1",
    INVITATION_SENT = "2",
    PUBLISHED = "3",
    ROUND_END = "4",
    SETTLED = "5",
    CANCELED = "6",
}